$(function () {
    if ($('form#FeeEditForm').length > 0) {

        if ($("#ChangesMadeError").html() != ""){
            $("#readonlyModal").modal('show');
        }

        if ($("#EffectiveDate").val() === "0001-01-01") {
            $("#EffectiveDate").val("");
        };

        $('#EffectiveDate').on('blur', function (e) {
            var date = $('#EffectiveDate').val();
            var template1 = $('#UpdateAutomaticMessageBody1Template').text();
            var template2 = $('#UpdateAutomaticMessageBody2Template').text();
            var templateManual = $('#UpdateManualMessageTemplate').text();

            $('#UpdateAutomaticMessageBody1').html(template1.replace('{0}', date));
            $('#UpdateAutomaticMessageBody2').html(template2.replace('{0}', date));
            $('#UpdateManualMessage').html(templateManual.replace('{0}', date));
        });


        $('#btnUpdate').on('click', function () {
            if (!$("#EffectiveDate").val()) {
                $("#id-EffectiveDate-error").removeAttr("hidden");
            }
            else{
                $("#id-EffectiveDate-error").attr("hidden", "hidden");

                //FieldValidationWarningMessage
                var attr = $("#FieldValidationWarningMessage").attr("hidden");
                if (isFieldValidationErrorJS && (typeof attr !== "undefined" && attr !== false && attr !== null)) {
                    $("#FieldValidationWarningMessage").removeAttr("hidden");
                }
                else
                {
                    //Is the admin note visible and empty?
                    if (isFieldValidationErrorJS && $('#AdminNote').length && $('#AdminNote').val().length == 0) {
                        $("#id-AdminNote-error").removeAttr("hidden");
                    }
                    else{
                        $("#id-AdminNote-error").attr("hidden", "hidden");

                        var updateDate = !$("#EffectiveDate").val() ? today : $("#EffectiveDate").val();

                        var message1 = saveMessage1JS.replace('[YYYY-MM-DD]', updateDate);
                        var message2 = saveMessage2JS.replace('[YYYY-MM-DD]', updateDate);

                        //Update the message
                        $("#saveModalMessage1").text(message1);
                        $("#saveModalMessage2").text(message2);

                        //Display the modal window
                        $("#saveModal").modal();
                    }
                }
            };            
        });

        $('#linkDisabledFee').on('click', function(){
            if($("#DisableFeeWarningMessage").hasClass("d-none")){
                $("#DisableFeeWarningMessage").removeClass("d-none");
            }
            else
            {
                $("#DisableFeeWarningMessage").addClass("d-none");
            }
        });

        $('#UpdateEnrollments-true').on('click', function () {
            $("#UpdateManualMessage").addClass("d-none");
            $("#UpdateAutomaticMessage").removeClass("d-none");            
        });

        $('#UpdateEnrollments-false').on('click', function () {
            $("#UpdateAutomaticMessage").addClass("d-none");
            $("#UpdateManualMessage").removeClass("d-none");
        });


        function validateDate(value) {
            var regEx = /^[0-9]{4}\-[0-9]{2}\-[0-9]{2}$/;
            return regEx.test(value);
        }

        function resetMaxPercentIncrease(){
            $("#MaxPercentIncreaseAllRB").prop('checked', false);
            $("#MaxPercentIncreaseInfantPreschoolRB").prop('checked', false)
            $("#MaxPercentIncreaseManually").prop('checked', false)
        }

        //Increase all values to the max value
        $("#MaxPercentIncreaseAllRB").on('click', function(){
            //Only update if the effective date is set
            if (!validateDate($("#EffectiveDate").val())) {
                resetMaxPercentIncrease();
                $("#id-EffectiveDate-error").removeAttr("hidden");
            }
            else {
                //We want to reload the page with the new options
                ReloadEditPage(calculateMarketFeeOptionAllJS);
            };
        });

        //Increase infant and preschool to max value
        $("#MaxPercentIncreaseInfantPreschoolRB").on('click', function(){
            //Only update if the effective date is set
            if (!validateDate($("#EffectiveDate").val())) {
                resetMaxPercentIncrease();
                $("#id-EffectiveDate-error").removeAttr("hidden");
            }
            else {
                //We want to reload the page with the new options
                ReloadEditPage(calculateMarketFeeOptionPreschoolJS);
            };
        });

        //Reset the values to their original values
        $("#MaxPercentIncreaseManually").on('click', function(){
            //Only update if the effective date is set
            if (!validateDate($("#EffectiveDate").val())) {
                resetMaxPercentIncrease();
                $("#id-EffectiveDate-error").removeAttr("hidden");
            }
            else {

                //We want to reload the page with the new options
                ReloadEditPage(calculateMarketFeeOptionManuallyJS);
            };
        });
                
        $('#buttonSave').on('click', function () {
             if (!validateDate($("#EffectiveDate").val())) {
                 resetMaxPercentIncrease();
                $("#id-EffectiveDate-error").removeAttr("hidden");
            }
            else {
                $("form").trigger("submit");
            };
        });

        $('#buttonCancel').on('click', function () {
            location.href = returnURLJS;
        });

        $('#buttonDelete').on('click', function () {
            var effectiveDate = $("#EffectiveDate").val();

            //Make an Ajax call to delete the record
            //using ajax
            var url = '';

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/license/fees/DeleteFee/' + operatorIdJS + '/';
            } else {
                url = location.href.split('/fr/')[0] + '/en/license/fees/DeleteFee/' + operatorIdJS + '/';
            }
            $.ajax({
                url: url + '?licenseNumber=' + licenseNumberJS + '&effectiveDate=' + effectiveDate + '&alternateId=' + alternateIdJS + '&licenceFeeTypeCd=' + licenceFeeTypeCdJS + '&feeUpdateAgeGroupType=' + feeUpdateAgeGroupTypeJS,
                method: 'POST',
                contentType: "application/json; charset=utf-8",
                processData: false,
                success: function (res) {
                    //redirect to the fees pages
                    window.location = returnURLJS;
                }
            });
        });
        
        $(".datepicker").on('blur', function () {
            if(!isAdminJS){
                ReloadEditPage("");
            }
        });

        function ReloadEditPage(feeoption){
            //Ensure the effective date value exists
            if (!validateDate($("#EffectiveDate").val())) {
                $("#id-EffectiveDate-error").removeAttr("hidden");
            }
            else {
                $("#id-EffectiveDate-error").attr("hidden", "hidden");

                //We need the license number and effective date
                var effectiveDate = $("#EffectiveDate").val();
                var url = reloadURLJS
                    .replace('changedate', effectiveDate)
                    .replace('ChangeFeeOption', feeoption);
                url += "&feeUpdateAgeGroupType=" + feeUpdateAgeGroupTypeJS

                location.href = url;
            }
        }

        function validateDecimal(value, langCode) {
            var regEx = /^[0-9]{0,3}$|^[0-9]{0,3}\.$|^[0-9]{0,3}\.[0-9]{0,2}$/;

            if(langCode == "fr"){
                regEx = /^[0-9]{0,3}$|^[0-9]{0,3}\,$|^[0-9]{0,3}\,[0-9]{0,2}$/;
            }

            return regEx.test(value);
        }


        $('.numericonly').keyup(function (e) {
            if (location.href.indexOf('/en/') > 0){

                //In english allow number and the period
                this.value = this.value.replace(/[^0-9\.]/g,'');

                //Make sure we are followin this format
                //999.00
                var valid = validateDecimal(this.value, 'en');
                if(!valid)
                {
                    //if value is not valid then blank it out
                    this.value = "";
                }
                
            }
            else{
                //in French allow number and the comma
                value = value.replace(/[^0-9\,]/g, '');

                //Make sure we are followin this format
                //999.00
                var valid = validateDecimal(this.value, 'fr');
                if(!valid){
                //if value is not valid then blank it out
                    this.value = "";
                }
            }
        });

        $(".warningboxtrigger").on('blur', function () {
            $("#FieldValidationWarningMessage").attr("hidden", "hidden");
            $("#id-AdminNote-error").attr("hidden", "hidden");
            $("#AdminNote").attr("hidden", "hidden");            
            isFieldValidationErrorJS = false;
        });

    } // if ($('form#FeeEditForm').length > 0)
}); // $(function () {